/**
 * @generated SignedSource<<1717b14b783c460fe842ae1f3f6000c0>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SignalDetailFooter_signal$data = {
  readonly opened: boolean;
  readonly " $fragmentSpreads": FragmentRefs<"SignalOpenedByEmployeeButton_signal">;
  readonly " $fragmentType": "SignalDetailFooter_signal";
};
export type SignalDetailFooter_signal$key = {
  readonly " $data"?: SignalDetailFooter_signal$data;
  readonly " $fragmentSpreads": FragmentRefs<"SignalDetailFooter_signal">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SignalDetailFooter_signal",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "opened",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SignalOpenedByEmployeeButton_signal"
    }
  ],
  "type": "Signal",
  "abstractKey": null
};

(node as any).hash = "6b884b2d98276edea99a56bc95ae06f1";

export default node;
